import { backendUrl } from '@shared/constants/urls/appUrls';

//Отправить запрос на получение превью подкаста
export const getPreviewPodcast = async () => {
  const url = `${backendUrl}/api/alpha/last-podcast-preview/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении превью подкаста: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получения превью подкаста:', error);
    throw error;
  }
};